import { TeamsSenderLayout } from "../TeamsSenderLayout";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { TeamsSenderEntities } from "../TeamsSenderEntities";
import { TeamsSenderRouterProps } from "../TeamsSenderRouterProps";

export interface IProviderPageProps extends NSARouterMakerResult, TeamsSenderRouterProps { }

function ProviderViewPage(props: IProviderPageProps)
{
	return (
		<TeamsSenderLayout {...props}
			action={{
				description: "This section displays detailed information about a selected Teams provider."
			}}
			pages={{
				entity: TeamsSenderEntities.provider(props),
				view: {}
			}}
		>
			<></>
		</TeamsSenderLayout>
	);
}

export default ProviderViewPage;